import progress from '@/xgzdService/progress-service'
import { MessageBox } from 'element-ui';

// 支持拓展导出类型
const typeList = [
    "DesignChange",
    "DesignChange2",
    "DesignChange3"
]
const isExportType = (type) => {
    return !!typeList.find(item => item == type)
}

export const exportExcel = () => {
    return {
        props: ['row'],
        render() {
            const { businessType,  flowBusinessId, status} = this.row
            // 满足导出类型和导出状态才可以导出
            return (isExportType(businessType) && status == 1) ? 
                <span style="cursor:pointer;color:#4777e7;" onClick={() => handleDownloadExcel(flowBusinessId)}>导出</span> : null
        }
    } 
}

const handleDownloadExcel = async (id) => {
   const res = await progress.exportDesignChange(id).catch(err => {
        console.error(err)
   })

   if (res instanceof Blob) {
        const fakeUrl = document.createElement('a')
        fakeUrl.href = URL.createObjectURL(res)
        // TODO:axios需要处理 content-disposition字段来获取后端想给的名称
        // 可以给res.toString返回定制的名称
        fakeUrl.setAttribute("download", res || "流程导出")
        fakeUrl.click()
   } else {
        throwError("导出excel异常")
   }
}

export const throwError = (msg) => {
    MessageBox({
        type: "error",
        message: msg
    })
}